import { Link, LinkVariant, RemoveIcon } from '@dreryk/react-components';

import { nfzSettingsTranslationKeys } from '../../../../../translations';

type EzwmSenderCodeRemoveModalOpenerProps = {
   readonly onClick: VoidFunction;
};

export const EzwmSenderCodeRemoveModalOpener = (props: EzwmSenderCodeRemoveModalOpenerProps): JSX.Element => {
   return (
      <Link
         testId={'openSenderCodeModal'}
         label={nfzSettingsTranslationKeys.removeCode}
         onClick={props.onClick}
         icon={<RemoveIcon />}
         variant={LinkVariant.ERROR}
      />
   );
};
